import styled from 'styled-components';
import { ICON_QUESTION_GRAY } from '@repo/assets';

type Props = {
  onClick: (e?: any) => void;
};

export const CashPickupGuideButton = ({ onClick }: Props) => {
  return (
    <CashPickupGuide id='cashPickupGuideButton' type='button' onClick={onClick}>
      <QuestionIcon
        id='cashPickupGuideButton'
        src={ICON_QUESTION_GRAY}
        alt=''
      />
      What is Western Union Cash Pickup?
    </CashPickupGuide>
  );
};

export default CashPickupGuideButton;

const CashPickupGuide = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #5f6165;
  text-decoration: underline;
  font-size: 14px;
  width: 100%;
  margin: 12px 0 8px;
`;

const QuestionIcon = styled.img`
  width: 18px;
  height: 18px;
`;
